export const getLngsltd = () => {
    try {
        return JSON.parse(localStorage.getItem('languageSelected'))
    } catch (error) {
        return null;
    }
}